import { type AuthHeader, authHeader } from "@roman/shared/lib/auth/authHeader";
import romanApi from "@roman/shared/lib/net/romanApi";
import type { MyPredictionMarketRanking } from "@roman/shared/types/PredictionMarket";
import type { SWRConfiguration } from "swr";
import useSWR from "swr";

export type MyPredictionMarketRankingProps = {
  predictionMarketId: string;
  swrOptions?: SWRConfiguration;
  fetcher?: (url: string, predictionMarketId: string, headers: AuthHeader) => Promise<MyPredictionMarketRanking>;
};

export const createDefaultMyPredictionMarketRankingFetcher = () => {
  return (url: string, predictionMarketId: string, headers: AuthHeader) => {
    return romanApi.get<MyPredictionMarketRanking>(
      `${url}/${predictionMarketId}`,
      undefined,
      headers ? { headers } : undefined,
    );
  };
};

export const useMyGetPredictionMarketRanking = ({
  predictionMarketId,
  swrOptions,
  fetcher,
}: MyPredictionMarketRankingProps) => {
  const headers = authHeader.getOrThrow();
  const rankingFetcher = fetcher || createDefaultMyPredictionMarketRankingFetcher();
  const swrKey = ["/prediction-market/my-rankings", predictionMarketId, headers];

  const swrQuery = useSWR<MyPredictionMarketRanking>(
    swrKey,
    ([url, id, headers]) => rankingFetcher(url, id, headers),
    swrOptions,
  );

  return swrQuery;
};
